import type { HTMLAttributes } from 'react';
import PageAction from 'components/shared/Routing/PageAction';
import type { TypeLinkDetailed } from 'types/autogen/contentful';
import { navigationLinkToPageAction } from '../../shared/ContentfulHelpers';

export default function WithAction({ link, ...restProps }: { link?: TypeLinkDetailed } & HTMLAttributes<HTMLElement>) {
    if (!link) return restProps.children;

    const { fields, metadata, sys } = link || {};
    const { children } = restProps;
    const action = navigationLinkToPageAction({ fields, metadata, sys });

    return action ? (
        <PageAction action={action} {...restProps}>
            {children}
        </PageAction>
    ) : (
        children
    );
}
